import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const GymTable = ({ gyms, onEdit, onToggleStatus }) => {
  return (
    <div className="card overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Status</th>
              <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Gym Name</th>
              <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Location</th>
              <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Contact</th>
              <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Members</th>
              <th className="text-right py-3 px-4 text-sm font-semibold text-foreground">Actions</th>
            </tr>
          </thead>
          <tbody>
            {gyms?.map((gym) => (
              <tr key={gym?.id} className="border-b border-border hover:bg-muted/50 transition-colors">
                {/* Status */}
                <td className="py-4 px-4">
                  <div className="flex items-center gap-2">
                    <div
                      className={`w-2 h-2 rounded-full ${
                        gym?.is_active ? 'bg-success' : 'bg-error'
                      }`}
                    />
                    <span className="text-sm text-foreground">
                      {gym?.is_active ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                </td>

                {/* Gym Name */}
                <td className="py-4 px-4">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                      <Icon name="Building2" size={16} color="var(--color-primary)" />
                    </div>
                    <span className="font-medium text-foreground">{gym?.name}</span>
                  </div>
                </td>

                {/* Location */}
                <td className="py-4 px-4">
                  <div className="text-sm text-foreground">
                    <p>{gym?.city}, {gym?.state}</p>
                    <p className="text-xs text-muted-foreground">{gym?.zip_code}</p>
                  </div>
                </td>

                {/* Contact */}
                <td className="py-4 px-4">
                  <div className="text-sm text-foreground">
                    {gym?.phone && (
                      <p className="flex items-center gap-1">
                        <Icon name="Phone" size={12} className="text-muted-foreground" />
                        {gym?.phone}
                      </p>
                    )}
                    {gym?.email && (
                      <p className="flex items-center gap-1 text-xs text-muted-foreground">
                        <Icon name="Mail" size={12} />
                        {gym?.email}
                      </p>
                    )}
                  </div>
                </td>

                {/* Members */}
                <td className="py-4 px-4">
                  <div className="flex items-center gap-1">
                    <Icon name="Users" size={14} className="text-muted-foreground" />
                    <span className="text-sm font-medium text-foreground">
                      {gym?.memberCount || 0}
                    </span>
                  </div>
                </td>

                {/* Actions */}
                <td className="py-4 px-4">
                  <div className="flex items-center justify-end gap-2">
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => onEdit(gym)}
                      title="Edit Gym"
                    >
                      <Icon name="Edit" size={16} />
                    </Button>
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => onToggleStatus(gym?.id, gym?.is_active)}
                      title={gym?.is_active ? 'Deactivate' : 'Activate'}
                    >
                      <Icon 
                        name={gym?.is_active ? 'XCircle' : 'CheckCircle'} 
                        size={16}
                        color={gym?.is_active ? 'var(--color-warning)' : 'var(--color-success)'}
                      />
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GymTable;
